import { Modal } from '@components';
import { routes } from '@constants';
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import { Button, Flex, Typography } from '@styles';
import { bool, func } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { string } from 'yup';

import { formatDate } from '../../screens/ProfilePage/ProfilePage.layoutProps';
import { layoutPropsByDevice } from './CertificationPassedModal.layoutProps';
import { styles } from './CertificationPassedModal.styles';

const CertificationPassedModal = ({ isVisible, levelTitle, setIsVisible }) => {
  const { t } = useTranslation();
  const { device, isTabletLG } = useScreenSize();
  const { navigate } = useNavigateWithOfflineMode();

  const layoutProps = layoutPropsByDevice[device || 'desktop'];

  const handleDownloadLaterButtonClick = () => {
    setIsVisible(false);
  };

  const handleDownloadNowButtonClick = () => {
    setIsVisible(false);
    navigate(routes.certificateSettings, {
      state: { date: formatDate(new Date().toISOString()), title: levelTitle },
    });
  };

  return (
    <Modal
      isVisible={isVisible}
      modalContainerProps={{
        ...styles.modalContainer,
        ...layoutProps.modalContainer,
      }}
      modalMaxHeight={isTabletLG ? '100vh' : '500px'}
      setModalVisible={setIsVisible}
      withCloseIcon={false}
    >
      <Flex {...styles.contentContainer} {...layoutProps.contentContainer}>
        <Typography {...layoutProps.title}>
          {t('CertificationPassedModal.Congratulations')}
        </Typography>
        <Typography {...layoutProps.subtitle}>
          {t('CertificationPassedModal.TextStart')}
          {levelTitle}!{t('CertificationPassedModal.TextEnd')}
        </Typography>
        <Flex {...layoutProps.buttonsContainer}>
          <Button
            onClick={handleDownloadLaterButtonClick}
            variant="secondary"
            width={isTabletLG ? '100%' : 335}
          >
            {t('CertificationPassedModal.DownloadLater')}
          </Button>
          <Button
            onClick={handleDownloadNowButtonClick}
            variant="primary"
            width={isTabletLG ? '100%' : 335}
          >
            {t('CertificationPassedModal.DownloadNow')}
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};

CertificationPassedModal.propTypes = {
  isVisible: bool.isRequired,
  levelTitle: string.isRequired,
  setIsVisible: func.isRequired,
};

export default CertificationPassedModal;
